import { render, staticRenderFns } from "./v-toggle-group.vue?vue&type=template&id=e3f79fe4&"
import script from "./v-toggle-group.vue?vue&type=script&lang=js&"
export * from "./v-toggle-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports